const MapMixin = {

	methods: {
		getMutationType (mut) {
			let type = "";

			if (mut.properties.nbapt1pp || mut.properties.nbmai1pp) {
				type = "T1";
			} else if (mut.properties.nbapt2pp || mut.properties.nbmai2pp) {
				type = "T2";
			} else if (mut.properties.nbapt3pp || mut.properties.nbmai3pp) {
				type = "T3";
			} else if (mut.properties.nbapt4pp || mut.properties.nbmai4pp) {
				type = "T4";
			} else if (mut.properties.nbapt5pp || mut.properties.nbmai5pp) {
				type = "T5";
			}
			return type;
		}
	}
};

export default MapMixin;